import { LOADER_SHOW, BTN_LOADER_SHOW, LOADER_HIDE, BTN_LOADER_HIDE } from 'actions/loader'

let _numberOfLoaders = 0;

export default (state = {overlay: true, _numberOfLoaders: 0}, action) => {
    switch (action.type) {
        case BTN_LOADER_SHOW:
            ++_numberOfLoaders;
            return Object.assign({}, {overlay: false}, {_numberOfLoaders: _numberOfLoaders});
        case LOADER_SHOW:
            return Object.assign({}, {overlay: true}, {_numberOfLoaders: ++_numberOfLoaders});
        case LOADER_HIDE:
            _numberOfLoaders = _numberOfLoaders <= 0 ? 0 : --_numberOfLoaders;
            return Object.assign({}, {overlay: true}, {_numberOfLoaders: _numberOfLoaders});
        case BTN_LOADER_HIDE:
            _numberOfLoaders = _numberOfLoaders <= 0 ? 0 : --_numberOfLoaders;
            return Object.assign({}, {overlay: false}, {_numberOfLoaders: _numberOfLoaders});
    }

    return state;
}